// extracted by mini-css-extract-plugin
module.exports = {"pictureContainer":"SellerProductDetailFormModal_pictureContainer__1vo7_","pictureOuterContainer":"SellerProductDetailFormModal_pictureOuterContainer__3Yp_m"};